import { useNotificationQuery } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotificationQuery";
import { useNotificationRealTimeUpdate } from "./useNotificationRealTimeUpdate";
export var useNotifications = function() {
    useNotificationRealTimeUpdate();
    var data = useNotificationQuery().data;
    var notifications = data === null || data === void 0 ? void 0 : data.notifications;
    var _notifications_length;
    return {
        notifications: notifications,
        notificationCount: (_notifications_length = notifications === null || notifications === void 0 ? void 0 : notifications.length) !== null && _notifications_length !== void 0 ? _notifications_length : 0
    };
};
